import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FILTER_ACTION_TYPE } from "../../../redux/actions-type";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/Checkbox.svg";

const weekDays = [
  { value: 1, name: "B.e" },
  { value: 2, name: "Ç.a" },
  { value: 3, name: "Ç" },
  { value: 4, name: "C.a" },
  { value: 5, name: "C" },
  { value: 6, name: "Ş" },
  { value: 7, name: "B" },
];

const DaysFilter = ({ deviceType }) => {
  const dispatch = useDispatch();
  const [selectedDays, setSelectedDays] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const toggleDay = (value) => {
    setSelectedDays((prev) => {
      const updated = prev.includes(value)
        ? prev.filter((d) => d !== value)
        : [...prev, value].sort((a, b) => a - b);

      dispatch({
        type: FILTER_ACTION_TYPE.GET_FILTER_DATA,
        payload: { days: updated }, // [1,3,5] formatında
      });

      return updated;
    });
  };

  // Yuxarıda göstərmək üçün seçilən günlərin adlarını yığırıq
  const selectedNames = weekDays
    .filter((day) => selectedDays.includes(day.value))
    .map((day) => day.name)
    .join(", ");

  return (
    <div
      ref={ref}
      className={`global-category-dropdown dropdown-name data-status ${deviceType} ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen((prev) => !prev)}
      >
        <h2>{selectedNames ? selectedNames : "Bütün Günlər"}</h2>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {weekDays.map((item,i) => (
            <li
              key={item.value}
              className={selectedDays.includes(item.value) ? "active" : ""}
              onClick={() => toggleDay(item.value)}
            >
                 {selectedDays.includes(item.value) && <CheckIcon />}
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DaysFilter;